import{useRootObjectLocale}from'./useRootObjectLocale';/**
 * The locale a single consultation block is currently read in.
 *
 * The block show pages (/library/consultation_block/:id/show and /settings/blocks/:type/:id)
 * are the only surfaces without a root object to follow, so the block itself is what the locale
 * is remembered per. Inside a consultation or an information clarification the block keeps
 * following its root object instead - see `useConsultationLocale` and
 * `useInformationClarificationLocale`.
 */export function useConsultationBlockLocale(consultationBlockId){return useRootObjectLocale('consultationBlock',consultationBlockId);}